import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ModalPassword from "../modal-password/component";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import ErrorHandler from "../error-handler/component";
import {cartRegister} from "../../services/cartRegister";
import ModalProfileImageSize from "../modal-profileimagesize/component";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import {imagesRegister} from "../../services/imagesRegister";
import {agentRegister} from "../../services/agentRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class UserAgents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            account: {
                email: "",
                name: "",
                surname: "",
                phone: "",
                permit: ''
            },
            modal: false,
            email: "",
            name: "",
            surname: "",
            phone: "",
            isLoading: true,
            error: false,
            form_error: false,
            agents: [],
            selected: null
        };
        this._setModal = this._setModal.bind(this);
    };

    componentWillMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/profile/agents');
            ReactGA4.send({ hitType: "pageview", page: "/user/profile/agents" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
        this.functions.account();
    }

    functions = {
        account: () => {
            dataRegister.account(salesChannelRegister.get('market')).then((user) => {
                let agents = [];
                if (Array.isArray(user.agents) && user.agents.length > 0) {
                    agents = user.agents;
                }
                this.setState({
                    agents: agents,
                    isLoading: false
                });
            }, (error) => {
                this.setState({
                    isLoading: false,
                    error: true
                })
            });
        },
        dataURItoBlob: (dataURI) => {
            try {
                var byteString;
                if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                    byteString = atob(dataURI.split(',')[1]);
                } else {
                    byteString = unescape(dataURI.split(',')[1]);
                }
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ia], {type: mimeString});
            } catch (e) {
                console.log(e);
            }
        },
        update: () => {
            this.setState({
                error: false
            }, () => {
                if (
                    this.state.account.name === "" ||
                    this.state.account.surname === "" ||
                    this.state.account.email === "" ||
                    this.state.account.phone === "" ||
                    !this.state.agent_image
                ) {
                    this.setState({
                        form_error: true
                    })
                } else {
                    this.setState({
                        loading_edit: true
                    }, () => {
                        this.state.account.profile_image = this.state.agent_image;
                        dataRegister.editAgent(salesChannelRegister.get('market'), this.state.account).then((response) => {
                            this.state.agents = response.agents;
                            this.setState({
                                agents: response.agents,
                                loading_edit: false,
                                account: {
                                    name: '',
                                    surname: '',
                                    email: '',
                                    phone: '',
                                    permit: ''
                                },
                                agent_image: null,
                            }, () => {

                                //UPDATE USER OBJECT WITH NEW AGENTS
                                let user = userRegister.getUser();
                                user.agents = this.state.agents;
                                userRegister.setUser(user);

                            })
                        }, (error) => {
                            this.setState({
                                loading_edit: false
                            })
                        });
                    })
                }
            })
        },
        save: () => {
            this.setState({
                error: false
            }, () => {
                console.log(this.state.account);
                if (
                    this.state.account.name === "" ||
                    this.state.account.surname === "" ||
                    this.state.account.email === "" ||
                    this.state.account.phone === "" ||
                    !this.state.agent_image
                ) {
                    this.setState({
                        form_error: true
                    })
                } else {
                    this.setState({
                        loading_agent: true
                    }, () => {
                        this.state.account.id = this.functions.makeId(28);
                        this.state.account.profile_image = this.state.agent_image;
                        dataRegister.postAgent(salesChannelRegister.get('market'), this.state.account).then((response) => {
                            this.setState({
                                agents: response.agents,
                                account: {
                                    name: '',
                                    surname: '',
                                    email: '',
                                    phone: '',
                                    permit: "",
                                },
                                create_agent: false,
                                agent_image: null,
                                loading_agent: false
                            }, () => {

                                //UPDATE USER OBJECT WITH NEW AGENTS
                                let user = userRegister.getUser();
                                user.agents = this.state.agents;
                                userRegister.setUser(user);

                            })
                        }, (error) => {
                            this.setState({
                                loading_agent: false
                            })
                        });
                    })
                }
            })
        },
        makeId: (length) => {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }
            return result;
        },
        remove: (item) => {
            if (item.id) {
                dataRegister.deleteAgent(salesChannelRegister.get('market'), {id: item.id}).then((response) => {

                    this.state.agents = this.state.agents.filter((agent) => {
                        return agent.id !== item.id;
                    });

                    this.setState({
                        agents: this.state.agents,
                    }, () => {
                        //UPDATE USER OBJECT WITH NEW AGENTS
                        let user = userRegister.getUser();
                        user.agents = this.state.agents;
                        userRegister.setUser(user);

                    })
                }, (error) => {

                });
            } else {
                this.setState({
                    name: "",
                    surname: "",
                    email: "",
                    phone: "",
                    permit: "",
                    agent_image: null
                })
            }
        }
    };

    _changeProfileImage(e) {
        try {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                if (files[0]) {
                    if (files[0].size < 2000000) {
                        let file = e.target.files[0];
                        this.setState({
                            agent_image_loader: true
                        }, () => {
                            let self = this;
                            const reader = new FileReader();
                            reader.addEventListener("load", () => {
                                let files = new FormData();
                                files.append('image', self.functions.dataURItoBlob(reader.result));
                                dataRegister.analyzeImage(files).then((response) => {
                                    if (response && response.images && response.images.small) {
                                        self.setState({
                                            agent_image: response.images.small,
                                            agent_image_loader: false
                                        })
                                    }
                                }, (error) => {
                                    self.setState({
                                        agent_image_loader: false
                                    })
                                });
                            });
                            reader.readAsDataURL(file);
                        })
                    } else {
                        this.setState({
                            size_modal: true
                        })
                    }
                }
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        agentRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _setModal() {
        this.setState({modal: false});
    }

    _renderProfileImage(list) {
        return (
            <div style={list?{marginBottom: "0px"}:{}} className={Styles.imagesContainerItem}>
                <div className={Styles.imagesContainerItemInner}>
                    {
                        !this.state.agent_image && !this.state.agent_image_loader &&
                        <div
                            style={this.state.form_error ? (salesChannelRegister.get('name') === "yieldlock" ? {color: '#E65032'} : {color: '#CC5430'}) : {}}
                            className={Styles.imagesContainerItemInnerIcon}>+</div>
                    }
                    {
                        this.state.agent_image && !this.state.agent_image_loader &&
                        <div style={{backgroundImage: "url(" + this.state.agent_image + ")"}}
                             className={Styles.imagesContainerItemInnerUploadImage}/>
                    }
                    {
                        this.state.agent_image_loader &&
                        <div className={Styles.imagesContainerItemLoader}>
                            <BeatLoader size={20} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
                {
                    !this.state.agent_image_loader && !this.state.account.id &&
                    <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                           onChange={(e) => this._changeProfileImage(e)} type="file" accept="image/jpeg, image/png"
                           className={Styles.imagesContainerItemInnerUpload}/>
                }
                {
                    this.state.agent_image && !this.state.agent_image_loader && !this.state.account.id &&
                    <div className={Styles.imagesContainerItemInnerIconPlus}>
                        <img className={Styles.imagesContainerItemInnerIconPlusIcon}
                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                               onChange={(e) => this._changeProfileImage(e)} type="file" accept="image/jpeg, image/png"
                               className={Styles.imagesContainerItemInnerUpload}/>
                    </div>
                }
            </div>
        )
    }

    _renderText(item) {
        return langRegister.get("user-profile", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.modal &&
                    <ModalPassword setModal={this._setModal}/>
                }
                {
                    this.state.size_modal &&
                    <ModalProfileImageSize setLeave={() => {
                        this.setState({
                            size_modal: false
                        })
                    }}/>
                }
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>

                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div onClick={() => {
                            this.setState({
                                create_agent: true,
                                account: {
                                    name: "",
                                    surname: "",
                                    email: "",
                                    phone: "",
                                    permit: ""
                                },
                                agent_image: null
                            })
                        }} className={Styles.button}>
                            <span className={Styles.buttonPlus}>+</span> <span
                            className={Styles.buttonText}>{this._renderText("item_29")}</span>
                        </div>
                    }
                    {
                        this.state.account && !this.state.isLoading &&
                        <div className={Styles.containerInner}>
                            {
                                this.state.create_agent &&
                                <div className={Styles.contentInnerItem}>
                                    {
                                        <div className={Styles.contentInnerItemHeader}>
                                            {
                                                !this.state.account.id &&
                                                <div className={Styles.contentInnerItemHeaderTitle}>
                                                    {this._renderText("item_30")}
                                                </div>
                                            }
                                            {
                                                this.state.account.id &&
                                                <div className={Styles.contentInnerItemHeaderTitle}>
                                                    {this.state.account.name}
                                                </div>
                                            }
                                            <div className={Styles.contentInnerItemHeaderButtons}>
                                                {
                                                    !this.state.account.id &&
                                                    <div onClick={() => {
                                                        if(this.state.account.id){
                                                            this.functions.update();
                                                        }else{
                                                            this.functions.save();
                                                        }
                                                    }} className={
                                                        cx(Styles.contentInnerItemHeaderEdit,
                                                            {
                                                                [Styles.contentInnerItemHeaderEditActive]: true
                                                            })
                                                    }>
                                                        {
                                                            this.state.loading_agent &&
                                                            <BeatLoader size={8} color={'#ffffff'}
                                                                        loading={true}/>
                                                        }
                                                        {
                                                            !this.state.loading_agent &&
                                                            <div>
                                                                {this._renderText("item_15")}
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    !this.state.edit_profile &&
                                                    <div onClick={() => this.setState({edit_profile: true})}
                                                         className={Styles.contentInnerItemHeaderEditMobile}>
                                                        <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                             src={require("../../assets/images/edit_button_moble.png")}/>
                                                    </div>
                                                }
                                                {
                                                    <div onClick={() => {
                                                        if(this.state.account.id){
                                                            this.functions.update();
                                                        }else{
                                                            this.functions.save();
                                                        }
                                                    }}
                                                         className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                                        <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                             src={require("../../assets/images/edit_button_moble.png")}/>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: false
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.name = event.target.value;
                                                this.setState({account: this.state.account})
                                            }} value={this.state.account.name}
                                                readOnly={this.state.loading_agent || this.state.account.id}
                                                placeholder={this._renderText("item_10") + "*"}
                                            />
                                            {
                                                this.state.form_error && this.state.account.name === "" &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                    className={Styles.inputError}/>
                                            }
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: false
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.surname = event.target.value;
                                                this.setState({account: this.state.account})
                                            }} value={this.state.account.surname}
                                                readOnly={this.state.loading_agent || this.state.account.id}
                                                placeholder={this._renderText("item_11") + "*"}
                                            />
                                            {
                                                this.state.form_error && this.state.account.surname === "" &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                    className={Styles.inputError}/>
                                            }
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: false
                                                        })
                                                }
                                                onChange={(event) => {
                                                    this.state.account.email = event.target.value.toLowerCase();
                                                    this.setState({
                                                        account: this.state.account
                                                    })
                                                }}
                                                value={this.state.account.email}
                                                readOnly={this.state.loading_agent || this.state.account.id}
                                                placeholder={this._renderText("item_12")}
                                            />
                                            {
                                                this.state.form_error && this.state.account.email === "" &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                    className={Styles.inputError}/>
                                            }
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: false
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.phone = event.target.value.trim();
                                                this.setState({account: this.state.account})
                                            }} value={this.state.account.phone}
                                                readOnly={this.state.loading_agent || this.state.account.id}
                                                placeholder={this._renderText("item_23") + "*"}
                                            />
                                            {
                                                this.state.form_error && this.state.account.phone === "" &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                    className={Styles.inputError}/>
                                            }
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: false
                                                        })
                                                }
                                                onChange={(event) => {
                                                    this.state.account.permit = event.target.value;
                                                    this.setState({account: this.state.account})
                                                }} value={this.state.account.permit}
                                                readOnly={this.state.loading_agent || this.state.account.id}
                                                placeholder={this._renderText("item_22")}/>
                                        </div>
                                    </div>
                                    {
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDivider}>
                                                {this._renderProfileImage()}
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.state.agents.sort((a, b) => b.name - a.name).map((item) => {
                                    return (
                                        <div>
                                            <div className={Styles.contentInnerItemList}>
                                                <div className={Styles.contentInnerItemHeaderList}>
                                                    <div className={Styles.contentInnerItemHeaderImage}>
                                                        <img className={Styles.contentInnerItemHeaderImageItem}
                                                             src={item.profile_image}/>
                                                    </div>
                                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                                        {item.name}
                                                    </div>
                                                    <div className={Styles.contentInnerItemHeaderId}>

                                                    </div>
                                                    <div className={Styles.cardStatusContainer}>

                                                    </div>
                                                    {
                                                        !this.state.edit_profile &&
                                                        <div onClick={() => {
                                                            this.setState({
                                                                account: item,
                                                                create_agent: false,
                                                                agent_image: item.profile_image
                                                            })
                                                        }}
                                                             className={Styles.contentInnerItemHeaderEdit}>
                                                            {this._renderText("item_3")}
                                                        </div>
                                                    }
                                                    {
                                                        item.id == this.state.account.id &&
                                                        <div onClick={() => {
                                                            this.functions.update();
                                                        }} className={
                                                            cx(Styles.contentInnerItemHeaderEdit,
                                                                {
                                                                    [Styles.contentInnerItemHeaderEditActive]: true
                                                                })
                                                        }>
                                                            {
                                                                this.state.loading_edit &&
                                                                <BeatLoader size={8} color={'#ffffff'}
                                                                            loading={true}/>
                                                            }
                                                            {
                                                                !this.state.loading_edit &&
                                                                <span>
                                                                    {this._renderText("item_15")}
                                                                </span>
                                                            }
                                                        </div>
                                                    }
                                                    {
                                                        item.id == this.state.account.id &&
                                                        <div onClick={() => {
                                                            this.functions.remove(item);
                                                        }}
                                                             style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#E65032'} : {}}
                                                             className={Styles.contentInnerItemHeaderDelete}>
                                                            {this._renderText("item_31")}
                                                        </div>
                                                    }
                                                    {
                                                        item.id == this.state.account.id &&
                                                        <div onClick={() => {
                                                            this.functions.remove(item);
                                                        }}
                                                             style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#E65032'} : {}}
                                                             className={cx(Styles.contentInnerItemHeaderDeleteMobile, Styles.contentInnerItemHeaderDeleteMobileRed)}>
                                                            <img className={Styles.contentInnerItemHeaderDeleteMobileIcon}
                                                                 src={require("../../assets/images/delete_button_mobile.png")}/>
                                                        </div>
                                                    }
                                                    {
                                                        item.id != this.state.account.id &&
                                                        <div onClick={() => {
                                                            this.setState({
                                                                account: item,
                                                                create_agent: false,
                                                                agent_image: item.profile_image
                                                            })
                                                        }} className={Styles.contentInnerItemHeaderEdit}>
                                                            {this._renderText("item_3")}
                                                        </div>
                                                    }
                                                    {
                                                        item.id != this.state.account.id &&
                                                        <div onClick={() => {
                                                            this.setState({
                                                                account: item,
                                                                create_agent: false,
                                                                agent_image: item.profile_image
                                                            })
                                                        }}
                                                             className={Styles.contentInnerItemHeaderEditMobile}>
                                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                                        </div>
                                                    }
                                                    {
                                                        item.id == this.state.account.id &&
                                                        <div onClick={() => {
                                                            this.functions.update();
                                                        }}
                                                             className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                                        </div>
                                                    }
                                                </div>

                                            </div>
                                            {
                                                item.id == this.state.account.id &&
                                                <div className={Styles.contentInnerItem}>
                                                    <div className={Styles.inputDivider}>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                                className={
                                                                    cx(Styles.input,
                                                                        {
                                                                            [Styles.inputDisabled]: false
                                                                        })
                                                                } onChange={(event) => {
                                                                this.state.account.name = event.target.value;
                                                                this.setState({account: this.state.account})
                                                            }} value={this.state.account.name}
                                                                readOnly={this.state.loading_edit}
                                                                placeholder={this._renderText("item_10") + "*"}
                                                            />
                                                            {
                                                                this.state.form_error && this.state.account.name === "" &&
                                                                <div
                                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                                    className={Styles.inputError}/>
                                                            }
                                                        </div>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                                className={
                                                                    cx(Styles.input,
                                                                        {
                                                                            [Styles.inputDisabled]: false
                                                                        })
                                                                } onChange={(event) => {
                                                                this.state.account.surname = event.target.value;
                                                                this.setState({account: this.state.account})
                                                            }} value={this.state.account.surname}
                                                                readOnly={this.state.loading_edit}
                                                                placeholder={this._renderText("item_11") + "*"}
                                                            />
                                                            {
                                                                this.state.form_error && this.state.account.surname === "" &&
                                                                <div
                                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                                    className={Styles.inputError}/>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={Styles.inputDivider}>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                                className={
                                                                    cx(Styles.input,
                                                                        {
                                                                            [Styles.inputDisabled]: false
                                                                        })
                                                                }
                                                                onChange={(event) => {
                                                                    this.state.account.email = event.target.value;
                                                                    this.setState({
                                                                        account: this.state.account
                                                                    })
                                                                }}
                                                                value={this.state.account.email}
                                                                readOnly={this.state.loading_edit}
                                                                placeholder={this._renderText("item_12")}
                                                            />
                                                            {
                                                                this.state.form_error && this.state.account.email === "" &&
                                                                <div
                                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                                    className={Styles.inputError}/>
                                                            }
                                                        </div>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                                className={
                                                                    cx(Styles.input,
                                                                        {
                                                                            [Styles.inputDisabled]: false
                                                                        })
                                                                } onChange={(event) => {
                                                                this.state.account.phone = event.target.value;
                                                                this.setState({account: this.state.account})
                                                            }} value={this.state.account.phone}
                                                                readOnly={this.state.loading_edit}
                                                                placeholder={this._renderText("item_23") + "*"}
                                                            />
                                                            {
                                                                this.state.form_error && this.state.account.phone === "" &&
                                                                <div
                                                                    style={salesChannelRegister.get('name') === "yieldlock" ? {borderColor: '#E65032'} : {}}
                                                                    className={Styles.inputError}/>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={Styles.inputDivider}>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                                className={
                                                                    cx(Styles.input,
                                                                        {
                                                                            [Styles.inputDisabled]: false
                                                                        })
                                                                }
                                                                onChange={(event) => {
                                                                    this.state.account.permit = event.target.value;
                                                                    this.setState({account: this.state.account})
                                                                }} value={this.state.account.permit}
                                                                readOnly={this.state.loading_edit}
                                                                placeholder={this._renderText("item_22")}/>
                                                        </div>
                                                    </div>
                                                    {
                                                        <div className={Styles.inputDividerItem}>
                                                            <div className={Styles.inputDivider}>
                                                                {this._renderProfileImage(true)}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }

                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.loader}>
                            <ErrorHandler/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default UserAgents;


// WEBPACK FOOTER //
// ./src/components/user-agents/component.js